module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page admin-page"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "admin-tab mt-4"
  }, [_c('v-tabs', {
    attrs: {
      "dark": "",
      "center-active": ""
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme for-tabs"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('v-tabs-bar', {
    staticClass: "tab_bar",
    attrs: {
      "dark": ""
    }
  }, [_c('div', {
    staticClass: "active-icon"
  }, [_vm._v("Admin >\n              ")]), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return (_vm.availableTab(tab)) ? _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": '#' + tab.id,
        "ripple": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))]) : _vm._e()
  })], 2)], 1)], 2), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    key: "users",
    attrs: {
      "id": "users"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'users') ? _c('user-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "albums",
    attrs: {
      "id": "albums"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'albums') ? _c('album-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "signups",
    attrs: {
      "id": "signups"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'signups') ? _c('signup-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "subscriptions",
    attrs: {
      "id": "subscriptions"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'subscriptions') ? _c('subscription-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "payments"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'payments') ? _c('payment-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "genres",
    attrs: {
      "id": "genres"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'genres') ? _c('genre-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "settings",
    attrs: {
      "id": "settings"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'settings') ? _c('setting-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "globalstats",
    attrs: {
      "id": "globalstats"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'globalstats') ? _c('globalstats-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "attendees",
    attrs: {
      "id": "attendees"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'attendees') ? _c('attendee-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "streams",
    attrs: {
      "id": "streams"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'streams') ? _c('stream-tab') : _vm._e()], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7df4a598","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/admin.vue
// module id = 1796
// module chunks = 180